import { useEffect, useState } from "react";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import "./style.css";

function CustomSelectAndList({ placeholder = "", options = [], id = "", onChange = () => { }, value = "", name = "" }) {

    const [val, setVal] = useState(value);
    const [list, setList] = useState([]);

    useEffect(() => {
        setVal(value);

    }, [value])


    useEffect(() => {
        onChange(list);
    }, [list]);

    const filteredOptions = options.filter(o => !list.find(l => l.value == o.value));

    return (
        <div id="custom-select-and-list" >
            <div className="custom-select-v2" id={id}>
                {placeholder && <h6>{placeholder}</h6>}
                <select name={name} onChange={(e) => {
                    setVal(e.target.value);

                    setList([...list, {
                        label: options.find(o => o.value == e.target.value)?.label,
                        value: e.target.value,
                    }]);
                }} value={val}>
                    {filteredOptions.map((option, index) => (
                        <option key={index} value={option.value}>{option.label}</option>
                    ))}
                </select>
            </div>

            <div className="csal-list">
                {
                    list.map((l, index) => (
                        <div key={"csal-" + index} className="csal-item">
                            <span>{l.label}</span>
                            <RemoveCircleOutlineIcon onClick={() => {
                                setList(list.filter(li => li.value != l.value));
                            }} />
                        </div>
                    ))
                }
            </div>
        </div >
    );
}


export default CustomSelectAndList;